import { render, staticRenderFns } from "./StudentEvents.vue?vue&type=template&id=1df568e2&scoped=true&"
import script from "./StudentEvents.vue?vue&type=script&lang=js&"
export * from "./StudentEvents.vue?vue&type=script&lang=js&"
import style0 from "./StudentEvents.vue?vue&type=style&index=0&id=1df568e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df568e2",
  null
  
)

export default component.exports